import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { RatingBar } from 'site-modules/lease-deals/components/rating-bar/rating-bar';
import { useRatingBar } from 'site-modules/lease-deals/hooks/use-rating-bar/use-rating-bar';

const createBarHeight = barId => barId * 3 + 1.5;

export function CompactRatingBar({
  value,
  className = null,
  barGap = undefined,
  barTextGap = undefined,
  ratingSize = 16,
}) {
  const { activeColor, bars } = useRatingBar({ value, createBarHeight });
  const { rating, maxRating } = value;
  const hasCustomBarTextGap = typeof barTextGap === 'number';

  return (
    <span
      className={classnames('d-flex', { 'gap-0_5': !hasCustomBarTextGap }, className)}
      style={hasCustomBarTextGap ? { gap: `${barTextGap}px` } : undefined}
    >
      <RatingBar activeColor={activeColor} bars={bars} rating={rating} barGap={barGap} />
      <span className="d-flex align-items-end">
        <span className="visually-hidden">Rating</span>
        <span className={classnames(`size-${ratingSize} lh-1 fw-bold text-${activeColor}`)}>{rating}</span>
        <span className={classnames(`size-12 lh-1 text-${activeColor}`)}>/{maxRating}</span>
      </span>
    </span>
  );
}

CompactRatingBar.propTypes = {
  value: PropTypes.shape({ rating: PropTypes.number, maxRating: PropTypes.number }).isRequired,
  className: PropTypes.string,
  barGap: PropTypes.number,
  barTextGap: PropTypes.number,
  ratingSize: PropTypes.number,
};
